<template>
  <div class="content">
    <div class="container">
      <h1 class="mb-5">
        Template & Help
      </h1>

      <nav-fulfillment :tab="tab" />
      <card-box>
        <card-title class="mb-2">
          Supported file formats
        </card-title>
        <p>
          In this format, you'll first include the attribute names in the first row (i.e., header) separated
          by a tab. Then starting on the second row, include the corresponding values under each attribute
          name. We recommend using a spreadsheet program such as Microsoft Excel or Google Sheets to create
          this and save the file as a comma-delimited file. If you’re using Google Sheets, you can download
          your file and upload it as a <span class="text-danger">.csv</span> file to Gearfury.
        </p>
        <p>
          Rows with matching Order ID’s are considered additional items for that Order ID. You generate Order
          ID numbers. Use ONLY numbers that do not exceed 7 numbers. E.g. 1234567
        </p>
        <p>
          Item SKU numbers for your art are available under the Merchant Help section after logging into your
          account.
        </p>

        <p>Available Sizes & Colors:</p>
        <table class="table  table-sm table-striped table-condensed">
          <tr>
            <th width="200">
              Styles
            </th>
            <th>Colors</th>
            <th width="200">
              Sizes
            </th>
          </tr>
          <tbody>
            <tr v-for="item in design.styles">
              <td><strong>{{ item.name }}</strong></td>
              <td>{{ showColor(item.colors) }}</td>
              <td>{{ showColor(item.sizes) }}</td>
            </tr>
          </tbody>
        </table>
      </card-box>
      <card-box>
        <card-title class="mb-2">
          Order data specification
        </card-title>
        <table class="table  table-sm table-striped table-condensed">
          <tbody>
            <tr />
          </tbody>
          <thead>
            <tr>
              <th>Column Name</th>
              <th>Data Type</th>
              <th>Required</th>
            </tr>
          </thead>


          <tbody>
            <tr>
              <td>order_id</td>
              <td>Int</td>
              <td>Yes</td>
            </tr>

            <tr>
              <td>shipping_name</td>
              <td>varchar</td>
              <td>Yes</td>
            </tr>

            <tr>
              <td>shipping_address_1</td>
              <td>varchar</td>
              <td>Yes</td>
            </tr>

            <tr>
              <td>shipping_address_2</td>
              <td>varchar</td>
              <td>No</td>
            </tr>

            <tr>
              <td>shipping_city</td>
              <td>varchar</td>
              <td>Yes</td>
            </tr>

            <tr>
              <td>shipping_state</td>
              <td>varchar (If country is United States must be two letter state code)</td>
              <td>Yes</td>
            </tr>

            <tr>
              <td>shipping_zipCode</td>
              <td>varchar</td>
              <td>Yes</td>
            </tr>

            <tr>
              <td>shipping_country</td>
              <td>varchar</td>
              <td>Yes</td>
            </tr>

            <tr>
              <td>shipping_phone</td>
              <td>varchar</td>
              <td>No *Recommended if country is not United States</td>
            </tr>

            <tr>
              <td>shipping_email</td>
              <td>varchar</td>
              <td>No *If used add email to like order ID's</td>
            </tr>

            <tr>
              <td>sku</td>
              <td>int</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>style</td>
              <td>varchar</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>size</td>
              <td>varchar</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>color</td>
              <td>varchar</td>
              <td>Yes</td>
            </tr>

            <tr>
              <td>quantity</td>
              <td>int</td>
              <td>Yes</td>
            </tr>
          </tbody>
        </table>
      </card-box>
    </div>
  </div>
</template>

<script>
    import CardBox from "../components/CardBox";
    import NavFulfillment from "../components/NavFulfillment";
    import CardTitle from "../components/CardTitle";

    export default {
        name: "FulfillmentTemplate",
        components: {CardTitle, NavFulfillment, CardBox},
        data: function () {
            return {
                tab: 'template',
                design: {},
                payment: {}
            }
        },
        mounted() {
            this.loadDesign()
        },
        methods: {
            showColor: function (color) {
                let out = []
                for (let i = 0; i < color.length; i++) {
                    out.push(color[i].name)
                }
                return out.join(', ')
            },
            loadDesign: function () {
                let vm = this
                this.$http.get(this.$config.api + 'design').then(function (res) {
                    vm.design = res.data
                });
            }
        }
    }
</script>

<style scoped>

</style>